module.exports = __webpack_public_path__ + "assets/img/LTC014.1d7d4644.png";